import React from 'react';
import AddProfilePictureRender from './AddProfilePictureRender';

export const AddProfilePicture=():JSX.Element=>{
	return <AddProfilePictureRender/>;
};